// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.printer-settings-view {
    display: block !important;
    width: 100% !important;
    box-sizing: border-box !important;
}

.search-wrapper {
    padding: 15px 20px !important;
    background: #ffffff !important;
    border-bottom: 1px solid #eeeeee !important;
}

.search-wrapper .text-input-field {
    margin: 0 !important;
}

.search-wrapper input {
    border: 1px solid #e0e0e0 !important;
    border-radius: 6px !important;
    padding: 8px 15px !important;
    font-size: 14px !important;
    transition: all 0.2s ease !important;
    background-color: #f9f9f9 !important;
}

.search-wrapper input:focus {
    border-color: var(--primary-theme, var(--rf-brand-lite)) !important;
    background-color: #ffffff !important;
    box-shadow: 0 0 0 2px rgba(var(--rf-brand-lite-rgb), 0.1) !important;
    outline: none !important;
    border-width: 1px !important;
}

.search-wrapper .input label {
    display: none !important;
}

.printers-vertical-stack {
    display: grid !important;
    grid-template-columns: 1fr !important;
    width: 100% !important;
    gap: 0 !important;
}

.printer-strip-row {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    width: 100% !important;
    min-height: 60px !important;
    background-color: #ffffff !important;
    border-bottom: 1px solid #eeeeee !important;
    padding: 0 20px !important;
    box-sizing: border-box !important;
    cursor: pointer !important;
    transition: background-color 0.2s ease !important;
    position: relative !important;
}

.printer-strip-row:hover {
    background-color: #fcfcfc !important;
}

.p-icon-box {
    position: absolute !important;
    left: 20px !important;
    width: 40px !important;
    display: flex !important;
    justify-content: flex-start !important;
    align-items: center !important;
    height: 100% !important;
}

.p-details-box {
    flex: 1 1 !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    text-align: left !important;
    padding-left: 50px !important;
    width: 100% !important;
}

.p-name-txt {
    font-size: 15px !important;
    font-weight: 600 !important;
    color: #333 !important;
    display: block !important;
}

.p-sub-details {
    display: flex !important;
    align-items: center !important;
    margin-top: 4px !important;
    gap: 8px !important;
}

.p-computer-txt {
    font-size: 13px !important;
    color: #555 !important;
    font-weight: 500 !important;
}

.p-status-dot {
    width: 8px !important;
    height: 8px !important;
    border-radius: 50% !important;
    display: inline-block !important;
}

.p-status-txt {
    font-size: 12px !important;
    text-transform: capitalize !important;
    color: #666 !important;
}

.p-id-txt {
    font-size: 12px !important;
    color: #999 !important;
    display: block !important;
}

.p-status-right-box {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    margin-left: auto !important;
    margin-right: 20px !important;
    flex-shrink: 0 !important;
}

.p-tag-box {
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    gap: 10px !important;
    pointer-events: none !important;
    flex-shrink: 0 !important;
}

.label-printer-badge {
    background: transparent !important;
    color: var(--primary-theme, var(--rf-brand-lite)) !important;
    border: 1px solid var(--primary-theme, var(--rf-brand-lite)) !important;
    padding: 3px 12px !important;
    border-radius: 20px !important;
    font-size: 11px !important;
    font-weight: 700 !important;
    white-space: nowrap !important;
    opacity: 0.8 !important;
    margin-right: 30px !important;
}

/* Modal styles */
.printer-modal-list {
    display: flex !important;
    flex-direction: column !important;
    width: 100% !important;
    margin-top: 15px !important;
}

.printer-modal-item {
    padding: 12px 15px !important;
    margin-bottom: 8px !important;
    border-radius: 8px !important;
    border: 1px solid #eeeeee !important;
    background: #ffffff !important;
    cursor: pointer !important;
    text-align: left !important;
    font-weight: 500 !important;
    transition: all 0.2s ease !important;
}

.printer-modal-item:hover {
    background: #f9f9f9 !important;
}

.printer-modal-item.selected {
    border-width: 1px !important;
    border-style: solid !important;
    font-weight: 700 !important;
    border-color: var(--primary-theme, var(--rf-brand-lite)) !important;
    background-color: rgba(var(--rf-brand-lite-rgb), 0.15) !important;
}
`, "",{"version":3,"sources":["webpack://./src/widgets/settings/PrinterConnection/style.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,2CAA2C;AAC/C;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;IACpC,6BAA6B;IAC7B,4BAA4B;IAC5B,0BAA0B;IAC1B,oCAAoC;IACpC,oCAAoC;AACxC;;AAEA;IACI,mEAAmE;IACnE,oCAAoC;IACpC,oEAAoE;IACpE,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,qCAAqC;IACrC,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,8BAA8B;IAC9B,sBAAsB;IACtB,2BAA2B;IAC3B,oCAAoC;IACpC,2CAA2C;IAC3C,0BAA0B;IAC1B,iCAAiC;IACjC,0BAA0B;IAC1B,iDAAiD;IACjD,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,sBAAsB;IACtB,wBAAwB;IACxB,sCAAsC;IACtC,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,oBAAkB;IAClB,wBAAwB;IACxB,iCAAiC;IACjC,kCAAkC;IAClC,2BAA2B;IAC3B,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;IAC1B,qCAAqC;IACrC,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,4BAA4B;IAC5B,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,oCAAoC;IACpC,oBAAoB;IACpB,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,4DAA4D;IAC5D,uEAAuE;IACvE,4BAA4B;IAC5B,8BAA8B;IAC9B,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA,iBAAiB;AACjB;IACI,wBAAwB;IACxB,iCAAiC;IACjC,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,oCAAoC;IACpC,8BAA8B;IAC9B,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;IAC9B,2BAA2B;IAC3B,mEAAmE;IACnE,iEAAiE;AACrE","sourcesContent":[".printer-settings-view {\n    display: block !important;\n    width: 100% !important;\n    box-sizing: border-box !important;\n}\n\n.search-wrapper {\n    padding: 15px 20px !important;\n    background: #ffffff !important;\n    border-bottom: 1px solid #eeeeee !important;\n}\n\n.search-wrapper .text-input-field {\n    margin: 0 !important;\n}\n\n.search-wrapper input {\n    border: 1px solid #e0e0e0 !important;\n    border-radius: 6px !important;\n    padding: 8px 15px !important;\n    font-size: 14px !important;\n    transition: all 0.2s ease !important;\n    background-color: #f9f9f9 !important;\n}\n\n.search-wrapper input:focus {\n    border-color: var(--primary-theme, var(--rf-brand-lite)) !important;\n    background-color: #ffffff !important;\n    box-shadow: 0 0 0 2px rgba(var(--rf-brand-lite-rgb), 0.1) !important;\n    outline: none !important;\n    border-width: 1px !important;\n}\n\n.search-wrapper .input label {\n    display: none !important;\n}\n\n.printers-vertical-stack {\n    display: grid !important;\n    grid-template-columns: 1fr !important;\n    width: 100% !important;\n    gap: 0 !important;\n}\n\n.printer-strip-row {\n    display: flex !important;\n    flex-direction: row !important;\n    align-items: center !important;\n    width: 100% !important;\n    min-height: 60px !important;\n    background-color: #ffffff !important;\n    border-bottom: 1px solid #eeeeee !important;\n    padding: 0 20px !important;\n    box-sizing: border-box !important;\n    cursor: pointer !important;\n    transition: background-color 0.2s ease !important;\n    position: relative !important;\n}\n\n.printer-strip-row:hover {\n    background-color: #fcfcfc !important;\n}\n\n.p-icon-box {\n    position: absolute !important;\n    left: 20px !important;\n    width: 40px !important;\n    display: flex !important;\n    justify-content: flex-start !important;\n    align-items: center !important;\n    height: 100% !important;\n}\n\n.p-details-box {\n    flex: 1 !important;\n    display: flex !important;\n    flex-direction: column !important;\n    justify-content: center !important;\n    text-align: left !important;\n    padding-left: 50px !important;\n    width: 100% !important;\n}\n\n.p-name-txt {\n    font-size: 15px !important;\n    font-weight: 600 !important;\n    color: #333 !important;\n    display: block !important;\n}\n\n.p-sub-details {\n    display: flex !important;\n    align-items: center !important;\n    margin-top: 4px !important;\n    gap: 8px !important;\n}\n\n.p-computer-txt {\n    font-size: 13px !important;\n    color: #555 !important;\n    font-weight: 500 !important;\n}\n\n.p-status-dot {\n    width: 8px !important;\n    height: 8px !important;\n    border-radius: 50% !important;\n    display: inline-block !important;\n}\n\n.p-status-txt {\n    font-size: 12px !important;\n    text-transform: capitalize !important;\n    color: #666 !important;\n}\n\n.p-id-txt {\n    font-size: 12px !important;\n    color: #999 !important;\n    display: block !important;\n}\n\n.p-status-right-box {\n    display: flex !important;\n    align-items: center !important;\n    gap: 8px !important;\n    margin-left: auto !important;\n    margin-right: 20px !important;\n    flex-shrink: 0 !important;\n}\n\n.p-tag-box {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: flex-end !important;\n    gap: 10px !important;\n    pointer-events: none !important;\n    flex-shrink: 0 !important;\n}\n\n.label-printer-badge {\n    background: transparent !important;\n    color: var(--primary-theme, var(--rf-brand-lite)) !important;\n    border: 1px solid var(--primary-theme, var(--rf-brand-lite)) !important;\n    padding: 3px 12px !important;\n    border-radius: 20px !important;\n    font-size: 11px !important;\n    font-weight: 700 !important;\n    white-space: nowrap !important;\n    opacity: 0.8 !important;\n    margin-right: 30px !important;\n}\n\n/* Modal styles */\n.printer-modal-list {\n    display: flex !important;\n    flex-direction: column !important;\n    width: 100% !important;\n    margin-top: 15px !important;\n}\n\n.printer-modal-item {\n    padding: 12px 15px !important;\n    margin-bottom: 8px !important;\n    border-radius: 8px !important;\n    border: 1px solid #eeeeee !important;\n    background: #ffffff !important;\n    cursor: pointer !important;\n    text-align: left !important;\n    font-weight: 500 !important;\n    transition: all 0.2s ease !important;\n}\n\n.printer-modal-item:hover {\n    background: #f9f9f9 !important;\n}\n\n.printer-modal-item.selected {\n    border-width: 1px !important;\n    border-style: solid !important;\n    font-weight: 700 !important;\n    border-color: var(--primary-theme, var(--rf-brand-lite)) !important;\n    background-color: rgba(var(--rf-brand-lite-rgb), 0.15) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
